/* --------------------
    States
-------------------- */
let showMenu = false; // Beim Laden ist das Menü geschlossen
let scrolled = false; // Beim Laden ist das Menü geschlossen

/* --------------------
    Event Handler
-------------------- */
$(document).on("click", ".hamburger", toggleMenu);
// $(document).on("click", ".overlay", toggleMenu);
$(document).on("click", ".header__navlink-arrow", openSubNavi);
$(window).resize(adjustSidebar);
$(document).ready(initStuff);

/* --------------------
    Functions
-------------------- */
function toggleMenu() {
  showMenu = !showMenu;
  $(".hamburger").toggleClass("is-active", showMenu);
  $("nav").toggleClass("is-active", showMenu);
  // $(".overlay").toggleClass("is-active", showMenu);
  $("body").toggleClass("no-body-scrolling");
}

//Sidebar
function adjustSidebar() {
  let padding = 4;
  if (window.innerWidth < 992) {
    $(".sidebar").css("transform", `translateX(${padding}px )`);
  } else {
    let scrollbarWidth =
      window.innerWidth - document.body.scrollWidth + padding;
    $(".sidebar").css("transform", `translateX(-${scrollbarWidth}px)`);
  }
}

//mobile sub navigation
function openSubNavi() {
  console.log($(this).parent());
  if (!$(this).parent().hasClass("open")) {
    $(".header__navlink").removeClass("open");
    $(this).parent().addClass("open");
  } else {
    $(this).parent().removeClass("open");
  }
}

//Stage-Menu
function initStuff() {
  //Menu Block
  $(".menu-block__button").on("mouseover", function (event) {
    let imgUrl =
      'url("' +
      event.target.closest(".menu-block__button").dataset.bgimage +
      '")';
    event.target.closest(".menu-block__buttonblock").style.backgroundImage =
      imgUrl;
  });

  $(window).resize(adjustSidebar);
  adjustSidebar();

  $(".header__searchbutton").on("click", function () {
    console.log("Searchbar Test");
    $(".header__searchbar").toggleClass("closed");
    $(".header__searchbutton").toggleClass("active");
  });

  // $(".stage__house-link").on("mouseover", function (event) {
  //   let textid = event.target.dataset.textid;
  //   $(".stage__house-text").hide();
  //   $("#" + textid).show();
  // });

  //Image Text Grid
  $(".imggrid-text__itemwrapper").on("click", function () {
    //hide all texts
    $(this)
      .parent()
      .find(".imggrid-text__scrollcontent")
      .css("display", "none");

    //show only selected text
    $("#" + $(this).find(".imggrid-text__item").data("textid")).css(
      "display",
      "block"
    );

    $(this).parent().find(".imggrid-text__scrollmark")[0].scrollIntoView();

    //change active item
    $(this).siblings().find(".imggrid-text__item").removeClass("active");
    $(this).find(".imggrid-text__item").addClass("active");
  });

  // Highlighten des Ankerpunkts beim Scrollen
  $(document).ready(function () {
    $(document).on("scroll", function () {
      var sections = $(".anker-item");
      var ankers = $(".anker-li");
      var viewHeight = window.innerHeight;
      if (sections.length != ankers.length) {
        // console.log(
        //   "Anzahl der Ankerelemente stimmt nicht mit der Anazhl der in der Anker-Nav befindlichen Links überein."
        // );
        return;
      }
      var currentSection = "";
      var j = 0;
      for (let i = 0; i < sections.length; i++) {
        var k = sections.length;
        k = k - 1;
        if (j < k) {
          var j = i + 1;
        }

        const element = sections[i];
        const nextElement = sections[j];

        var activeElementTop = $(element).offset().top;
        var nextElementTop = $(nextElement).offset().top;

        var currentScrollPosition = $(document).scrollTop();
        currentScrollPosition = currentScrollPosition + 0.25 * viewHeight;
        if (
          (currentScrollPosition > activeElementTop &&
            currentScrollPosition < nextElementTop) ||
          (currentScrollPosition > activeElementTop && j == k)
        ) {
          var previousElement =
            document.getElementsByClassName("activeanker")[0];
          $(".anker-li").removeClass("activeanker");
          currentSection = $(element).attr("id");

          //Workaround für Firefox
          /* if(navigator.userAgent.match(/firefox|fxios/i)){
            if(previousElement != undefined){
              console.log("Prev: " + previousElement.id + " / New: " + "anker-li-" + currentSection);
              if(previousElement && previousElement.id != "anker-li-" + currentSection){
                console.log("Firefox mode...");
                document.getElementById("anker-li-" + currentSection).scrollIntoView({block: "nearest", inline: "center", behaviour: "instant"});
              }
            }
          } else {
            document.getElementById("anker-li-" + currentSection).scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center"});
          } */

          currentSection = "#anker-li-" + currentSection;
          $(currentSection).addClass("activeanker");
        } else {
          // console.log("Nein");
        }
      }
    });
  });

  //Circle Slider
  $(document).ready(function () {
    if ($(".stage-circle-slider__slider")[0] || true) {
      $(".stage-circle-slider__slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        fade: true,
      });
    }
  });

  // Menu Block Carousel
  $(document).ready(function () {
    $(".menu__slider").each((key, item) => {
      $(item).slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        adaptiveHeight: false,
        prevArrow: $(item).parent().find(".menu-block-carousel__arrow-prev"),
        nextArrow: $(item).parent().find(".menu-block-carousel__arrow-next"),
      });
    });
  });

  //showmore
  $(document).ready(function () {
    $(".showmore").on("click", function () {
      $(this).siblings(".showmore-indicator").show();
      $(this).siblings(".showless").show();
      $(this).hide();
    });
  });

  //showless
  $(document).ready(function () {
    $(".showless").on("click", function () {
      $(this).siblings(".showmore-indicator").hide();
      $(this).siblings(".showmore").show();
      $(this).hide();
    });
  });

  //Header logo
  $(document).ready(function () {
    $(document).on("scroll", function () {
      var currentScrollPosition = $(document).scrollTop();
      // console.log(currentScrollPosition);
      if (currentScrollPosition > 500) {
        $(".header__logo").addClass("scrolled");
        $(".header").addClass("scrolled");
      }
      if (currentScrollPosition < 500) {
        $(".header__logo").removeClass("scrolled");
        $(".header").removeClass("scrolled");
      }
    });
  });
}
